<template>
    <div class="wl-container" v-loading="loading">
        <client-list class="mgb5"/>
    </div>

</template>
<script>
    import ClientList from './client-list';
    import {mapGetters} from 'vuex';
    import API from '@/api';
    
    export default {
        name: 'client-home',
        data() {
            return {
                active: '2',
                contactList: [],
                KPcontactList: [],
                loading: false
            };
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite',
                getUser: 'getUser'
            })
        },
        async mounted() {
            // this.ifRole()
            this.loading = true
            // await this.getClientContact();
            // await this.getKPContact();
            await this.showSetSession()
            await this.getConfirmationAuth()
            this.loading = false
        },
        methods: {
            // ifRole() {
            //     if (!this.getUser.clientRoleIds || this.getUser.clientRoleIds.length == 0) {

            //     }
            // },
            async queryMenuList(siteId){
              let menuCodeList = []
              
              if (this.getUser.userType == '1') {
                const res = await API.componentUserRoles.queryClientMenu({siteId: siteId})
                if (res.code == '1') {
                    if (res.data && res.data.length) {
                        menuCodeList = res.data.map(item => item.menuCode)
                    }
                    this.$store.commit('common/setShowMenuCodeList', menuCodeList)
                    return menuCodeList
                }
              } else if (this.getUser.userType == '2') {
                  const res2 = await API.general.getClientTile({siteId: siteId})
                  //用于处理客户端用户没有角色的特殊场景
                  if(res2.code == '1') {
                    menuCodeList = res2.data
                    this.$store.commit('common/setShowMenuCodeList', menuCodeList)
                    return menuCodeList
                  }  
              }
            },
            async getConfirmationAuth() {
                const menuCodeList = await this.queryMenuList(this.getSite.siteId)
                if (this.getUser.userType === '2') {
                    const clientMenus = [
                        {
                            "parentCode": "client000",
                            "menuCode": "client001",
                            "menuName": "Information Submission ",
                            "menuType": "client",
                            "href": "pbc",
                            "sort": 1,
                            "icon": "",
                            "childMenuList": []
                        },
                        {
                            "parentCode": "client000",
                            "menuCode": "client005",
                            "menuName": "Information Exchange",
                            "menuType": "client",
                            "href": "exchange",
                            "sort": 2,
                            "icon": "",
                            "childMenuList": []
                        },
                        {
                            "parentCode": "client000",
                            "menuCode": "client002",
                            "menuName": "Statutory Accounts Status",
                            "menuType": "client",
                            "href": "accounts",
                            "sort": 3,
                            "icon": "",
                            "childMenuList": []
                        },
                        {
                            "parentCode": "client000",
                            "menuCode": "client003",
                            "menuName": "Matter Logs",
                            "menuType": "client",
                            "href": "matterLogs",
                            "sort": 4,
                            "icon": "",
                            "childMenuList": []
                        },
                        {
                            "parentCode": "client000",
                            "menuCode": "client004",
                            "menuName": "Insights",
                            "menuType": "client",
                            "href": "insights",
                            "sort": 5,
                            "icon": "",
                            "childMenuList": []
                        },
                        {
                            "parentCode": "client000",
                            "menuCode": "client006",
                            "menuName": "Confirmation",
                            "menuType": "client",
                            "href": "confirmation",
                            "sort": 6,
                            "icon": "",
                            "childMenuList": []
                        }
                    ].filter(v => menuCodeList.includes(v.menuCode))
                    if (!this.$store.state.common.currentMenu.find(v => v.menuCode == 'client000')) {
                        this.$store.state.common.currentMenu.push({
                            childMenuList: [],
                            href: "client",
                            icon: "icon-menu4",
                            menuCode: "client000",
                            menuName: "Client Home",
                            menuType: "client",
                            parentCode: "",
                            sort: 3
                        })
                    }
                    clientMenus.forEach(v => {
                        if (!this.$store.state.common.currentMenu.find(vv => vv.menuCode == 'client000').childMenuList.find(vv => vv.menuCode == v.menuCode)) {
                            this.$store.state.common.currentMenu.find(vv => vv.menuCode == 'client000').childMenuList.push(v)
                        }
                    })

                    this.$store.state.common.user.menuList = this.$store.state.common.currentMenu
                }
            },
            async showSetSession() {
                const flag = localStorage.getItem('first_login_homepage_show_set_session')
                if (flag) {
                    localStorage.removeItem('first_login_homepage_show_set_session')
                    this.$nextTick(() => {
                        this.$showConfigOutTime()
                    })
                }
            },

            getClientContact() {
                API.common.queryClientContact({siteId: this.getSite.siteId}).then(res => {
                    if (res.code == '1' && res.data && res.data.length > 0) {
                        /*this.contactList = res.data;*/
                        for (let i = 0; i <= res.data.length; i += 4) {
                            this.contactList.push(res.data.slice(i, i + 4))
                        }
                    }
                    if (res.code !== '1') {
                        this.$message.error(this.$t(res.code));
                    }
                });
            },
            getKPContact() {
                API.common.queryKPContact({siteId: this.getSite.siteId}).then(res => {
                    if (res.code == '1' && res.data && res.data.length > 0) {
                        for (let i = 0; i <= res.data.length; i += 4) {
                            this.KPcontactList.push(res.data.slice(i, i + 4))
                        }
                    }
                    if (res.code !== '1') {
                        this.$message.error(this.$t(res.code));
                    }
                });
            }
        },
        components: {
            ClientList,
        }
    };
</script>

<style scoped>
    .mgb25 {
        margin-bottom: 25px;
    }
    .mgb5 {
        margin-bottom: 5px;
    }
    .wl-container {
        padding: 15px;
        padding-top: 0;
        color: #444;
        height: 100%;
        background: #eff1f5;
    }

    .wl-tab {
        background: #ffffff;
        height: 100%;
    }
</style>
